export enum SearchBreadcrumbModifier {
  NO_MARGIN_BOTTOM = 'search-breadcrumb__item--no-margin-bottom',
}
